import { parseUF } from './utils.js';

export function actualizarResumen(cuotasData, valorUF, cuotasValidas, selectElement, elements) {

    if (!selectElement || !elements) {
        return;
    }

    const index = parseInt(selectElement.value);
    const cuotasElegidas = cuotasValidas[index];


    if (!cuotasElegidas) {
        return;
    }

    const infoCuota = cuotasData?.[cuotasElegidas];

    if (!infoCuota) {
        console.error("❌ No hay datos para", cuotasElegidas, "cuotas");
        return;
    }

    const parseUF = (value) => {
        if (typeof value === 'number') return value;
        if (typeof value === 'string') {
            // Reemplazar coma por punto y convertir a número
            return parseFloat(value.replace(',', '.')) || 0;
        }
        return 0;
    };

    const totalUF = parseUF(infoCuota.uf_total || infoCuota.total_cuotas || infoCuota.total || 0);
    const mensualUF = parseUF(infoCuota.uf_mensual || infoCuota.valor_cuota || infoCuota.mensual || (totalUF / cuotasElegidas));

    console.log("💰 Valores calculados:", { totalUF, mensualUF });

    const clp = Math.round(mensualUF * valorUF);

    elements.total.textContent = `${totalUF.toFixed(1)} UF`;
    elements.month.textContent = `${mensualUF.toFixed(2)} UF`;
    elements.clp.textContent = `$ ${clp.toLocaleString('es-CL')}`;

    if (elements.label) {
        elements.label.textContent = `${cuotasElegidas} cuotas`;
    }
}
